<div class="bolt-container no-pad">
  <div class="bolt-row column-headers">
    <div class="bolt-col-6 no-pad">Coverages</div>
    <div class="bolt-col-4 no-pad align-right">{{deductibleColumnHeaderLabel}}</div>
    @if (showPremium) {
      <div class="bolt-col-2 no-pad align-right">Premium</div>
    }
  </div>
  @for (row of displayRows; track row.label) {
    <div class="bolt-row">
      <div class="bolt-col-6 no-pad">{{row.label}}</div>
      <div class="bolt-col-4 no-pad align-right">{{row.deductible}}</div>
      @if (showPremium) {
        <div class="bolt-col-2 no-pad align-right">{{row.premium}}</div>
      }
    </div>
  }
</div>
